import { isTruthy } from "~/tools/is-truthy";

import type { FullRelation } from "../../../../../../main/common/openapi";

export const getRelationName = (
	{ data, source, target }: FullRelation,
	relationTypeName: undefined | string,
): string => {
	if (data.name) {
		return data.name;
	}

	return [source.data.name, relationTypeName, target.data.name].filter(isTruthy).join(" ");
};

export const geComponentName = (componentName: string, componentTypeName: undefined | string): string => {
	if (!componentTypeName) {
		return componentName;
	}

	return `${componentName} (${componentTypeName})`;
};
